var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"portal"}},[(_vm.loading)?_c('Loading',{staticClass:"p-8"}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }